/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type RoadmapViewClassicEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const roadmapViewClassicEntrypoint: EntryPoint<RoadmapViewClassicEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<RoadmapViewClassicEntrypointComponent>(
			/* webpackChunkName: "async-classic-roadmap-entrypoint" */ './ExportedDefault.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
